/* eslint-disable */

import Vue from 'vue';
import Vuex from 'vuex';
import VersionData from '../components/data/versionData.js';
import SutraData from '../components/data/sutraData.js';
import Mp3Data from '../components/data/mp3Data.js';
import Vocabularies from '../components/data/vocabularies.js';
import VocabulariesPS from '../components/data/vocabulariesPS.js';

Vue.use(Vuex);

export const store = new Vuex.Store({
 state: {
  versionList: [],
  sutraList: [],
  mp3List: [],
  vocabulariesList: [],
  vocabulariesPSList: [],
  selected: null,
  contraParent: null,
  tagClick: true,
  hasNoSameTag: false,
  mouseX: null,
  mouseY: null,
 },
 mutations: {
   setVersionList (state, data) {
     state.versionList = data;
   },
   setSutraList (state, data) {
     state.sutraList = data;
   },
   setMp3List (state, data) {
     state.mp3List = data;
   },
   setVocabulariesList (state, data) {
     state.vocabulariesList = data;
   },
   setVocabulariesPSList (state, data) {
    state.vocabulariesPSList = data;
  },
   updateSelected(state, selected) {
     if (selected !== null) {
       state.selected = selected.toString();
     } else {
       state.selected = null;
     };
   },
   updateMouseX(state, mouseX) {
     if (mouseX !== null) {
       state.mouseX = mouseX.toString();
     } else {
       state.mouseX = null;
     };
   },
   updateMouseY(state, mouseY) {
     if (mouseY !== null) {
       state.mouseY = mouseY.toString();
     } else {
       state.mouseY = null;
     };
   },
   updateContraParent(state, contraParent) {
     if (contraParent == 0) {
       state.contraParent = null;
     } else {
       contraParent == 'left' ?
       state.contraParent = 'right' : state.contraParent = 'left';
     }
   },
   updateTagClick(state, tagClick) {
     tagClick === 1?
     state.tagClick = !state.tagClick:'';
     if (tagClick === 0) {
       state.tagClick = true;
     };
   },
   updateHasNoSameTag(state, hasNoSameTag) {
     state.hasNoSameTag = (hasNoSameTag === true)? true : false;
   }
 },
 actions: {
   getVersionList (context) {
     setTimeout(() => {
       context.commit('setVersionList', VersionData);
     }, 500);
   },
   getSutraList (context) {
     setTimeout(() => {
       context.commit('setSutraList', SutraData);
     }, 500);
   },
   getMp3List (context) {
     setTimeout(() => {
       context.commit('setMp3List', Mp3Data);
     }, 500);
   },
   getVocabulariesList (context) {
     setTimeout(() => {
       context.commit('setVocabulariesList', Vocabularies);
     }, 500);
   },
   getVocabulariesPSList (context) {
    setTimeout(() => {
      context.commit('setVocabulariesPSList', VocabulariesPS);
    }, 500);
   },

 },
 getters: {
   versions: state => {
     const getFilterArray = (array) => {
       const res = [];
       const json = {};
       for (let i = 0; i < array.length; i++){
           const _self = array[i];
           if(!json[_self]){
               res.push(_self);
               json[_self] = 1;
           }
       }
       return res;
     }
     const versions = state.versionList.map(item => item.id);
     return getFilterArray(versions);
   },
   sutras: state => {
     const getFilterArray = (array) => {
       const res = [];
       const json = {};
       for (let i = 0; i < array.length; i++){
           const _self = array[i];
           if(!json[_self]){
               res.push(_self);
               json[_self] = 1;
           }
       }
       return res;
     }
     const sutras = state.sutraList.map(item => item.sutraId);
     return getFilterArray(sutras);
   },
   mp3s: state => {
     const getFilterArray = (array) => {
       const res = [];
       const json = {};
       for (let i = 0; i < array.length; i++){
           const _self = array[i];
           if(!json[_self]){
               res.push(_self);
               json[_self] = 1;
           }
       }
       return res;
     }
     const mp3s = state.mp3List.map(item => item.mp3);
     return getFilterArray(mp3s);
   },
 },
});



// WEBPACK FOOTER //
// ./src/store/store.js